import { render, staticRenderFns } from "./eAristoProfessorTopicsRootView.vue?vue&type=template&id=8e08c6be"
import script from "./eAristoProfessorTopicsRootView.vue?vue&type=script&lang=js"
export * from "./eAristoProfessorTopicsRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports